import type { TAdditionalCostType } from 'api/swagger';

export const AdditionalCostType: Record<TAdditionalCostType, string> = {
  fine: 'Fine from customer',
  clients_mistake: "Client's mistake",
  warehouse_cost: 'Warehouse cost',
  partners_warehouse_cost: "Partner's warehouse cost",
  customs_cost: 'Customs cost',
  other: 'Other',
};
